//
export default {

  /**
   * 
   */
  toAccounting: () => [
    {
      name: 'accounting_date',
      type: 'date-field',
      flex: {
        xs12: true,
      },
      props: {
        label: 'Fecha contable',
      },
    }
  ]
}
